import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {
    accountSearchResultCrmIntegrationDataSelector,
    accountSearchResultCrmIntegrationResultSelector,
} from '../../slices/account-search-result-crm-integration.slice';

type Props = {
    accountId: number,
};

export const SalesforceIntegrationCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultCrmIntegrationDataSelector);
    const result = useSelector(accountSearchResultCrmIntegrationResultSelector);

    const salesforceEnabled = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].sfdcEnabled ? 'Yes' : 'No';
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !salesforceEnabled) {
        return null;
    }

    return (
        <span>{salesforceEnabled}</span>
    );
};
